import React from 'react';

// Product images mapping (same as ProductSelectionStep)
const productImages = {
  'windows': 'https://foxwindowsanddoors.com/app/uploads/form/windows.png',
  'internal-products': 'https://foxwindowsanddoors.com/app/uploads/form/AluminiumDoors.png',
  'front-back-doors': 'https://foxwindowsanddoors.com/app/uploads/2024/03/Spitfire-Front-Doors.jpg',
  'bifolding-sliding-french-doors': 'https://foxwindowsanddoors.com/app/uploads/form/Bifolding.jpg',
  'conservatories': 'https://foxwindowsanddoors.com/app/uploads/form/Conservatories & Extensions.png',
  'conservatory-roofs': 'https://foxwindowsanddoors.com/app/uploads/form/Conservatory Roofs.png',
  'verandas-pergolas': 'https://foxwindowsanddoors.com/app/uploads/form/Verandas.png',
};

const ThankYouStep = ({ onStartNewQuote, product }) => {
  // Get the product image based on selected product
  const getProductImage = () => {
    if (product && productImages[product]) {
      return productImages[product];
    }
    return 'https://foxwindowsanddoors.com/app/uploads/form/windows.png';
  };

  return (
    <div className="w-full">
      {/* Request Submitted Header */}
      <h2 className="mb-8 text-center text-[24px] font-bold text-black">
        Request Submitted
      </h2>

      {/* Product Image with Gradient */}
      <div className="relative mx-auto max-w-[1240px] px-4">
        <div className="relative h-[400px] overflow-hidden rounded-lg">
          <img
            src={getProductImage()}
            alt="Your Selected Product"
            className="h-full w-full object-cover"
          />
          {/* Gradient overlay at bottom */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        </div>
      </div>

      {/* Gray Section with Thank You Message */}
      <div className="mt-8 bg-[#F3F4F6] py-12">
        <div className="mx-auto max-w-[600px] px-4 text-center">
          <h3 className="mb-4 text-[28px] font-bold text-black">
            We will review your quote request, and a member of our team will get back to you as soon as possible.
          </h3>

          <p className="mb-8 text-[16px] text-[#4c4c4c]">
            In the meantime, feel free to browse our <a href='https://foxwindowsanddoors.com/gallery/'>gallery</a> , read one of our <a href='https://foxwindowsanddoors.com/brochures/'>guides</a> , or explore our showroom. You can pop in any time, or take a look around <a href='https://foxwindowsanddoors.com/book-a-showroom-visit/'> our virtual showroom online</a>.
          </p>

          {/* Start New Quote Button */}
          <button
            type="button"
            onClick={onStartNewQuote}
            className="rounded-md bg-[#ED6B64] px-12 py-4 text-sm font-normal tracking-wider text-white transition-colors hover:bg-[#d85a54]"
          >
            START A NEW QUOTE
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThankYouStep;
